import { frontendURL } from '../../../helper/URLHelper';
import RentalBranches from './Index.vue';
import ViewBranch from './components/ViewBranch.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/rental_branches'),
      name: 'rental_branches',
      component: RentalBranches,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      // Router guard to check subscription using cached data
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    },
    {
      path: frontendURL('accounts/:accountId/rental_branches/:branchId'),
      name: 'view_rental_branch',
      component: ViewBranch,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      // Router guard to check subscription using cached data
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    }
  ],
};
